import { useQuery } from '@tanstack/react-query'
import { apiClient } from '@/lib/api'
import { UsageStats } from '../types'
import { ApiError } from '@/lib/api'
import { useState, useEffect } from 'react'
interface UseUsageStatsReturn {
  usageStats: UsageStats | null
  loading: boolean
  error: string | null
  refetch: () => Promise<void>
}

export function useUsageStats(): UseUsageStatsReturn {
  const [usageStats, setUsageStats] = useState<UsageStats | null>(null)
  const [loading, setLoading] = useState(true)
  const [error, setError] = useState<string | null>(null)

  const fetchUsageStats = async () => {
    try {
      setLoading(true)
      setError(null)
      
      // const data = await apiClient.getUsageStats()
      // setUsageStats(data)
    } catch (err) {
      if (err instanceof ApiError) {
        setError(`Failed to fetch usage statistics: ${err.message} (Code: ${err.code})`)
      } else {
        setError(err instanceof Error ? err.message : 'Failed to fetch usage statistics')
      }
      console.error('Error fetching usage stats:', err)
    } finally {
      setLoading(false)
    }
  }

  useEffect(() => {
    fetchUsageStats()
  }, [])

  return {
    usageStats,
    loading,
    error,
    refetch: fetchUsageStats
  }
}